import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import SuspenseFallback from "../components/shared/SuspenseFallback";

const LoginPage = lazy(() => import(/* webpackChunkName: "LoginPage" */ "../pages/Login"));
const RegisterPage = lazy(() => import(/* webpackChunkName: "RegisterPage" */ "../pages/Register"));
const ErrorPage = lazy(() => import(/* webpackChunkName: "ErrorPage" */ "../pages/ErrorPage"));
const ForgotPasswordPage = lazy(
  () => import(/* webpackChunkName: "ErrorPage" */ "../pages/ForgotPassword"),
);
const NewPasswordPage = lazy(
  () => import(/* webpackChunkName: "ErrorPage" */ "../pages/NewPassword"),
);
const Subscription = lazy(
  () => import(/* webpackChunkName: "ErrorPage" */ "../pages/Subscription"),
);

const NotAuthorized = () => (
  <Suspense fallback={<SuspenseFallback />}>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/new-password/:token" element={<NewPasswordPage />} />
      <Route path="/subscription-form/:token" element={<Subscription />} />
      <Route path="/subscribe/:link" element={<Subscription />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  </Suspense>
);

export default NotAuthorized;
